import { SuggestedChangeDataSet } from '@schooly/constants';
import React, { FC } from 'react';

import { LongStringWithTooltip } from '../../../../components/uikit-components/LongStringWithTooltip/LongStringWithTooltip';
import { useProfile } from '../../../../context/profile/useProfile';
import ProfileProperty from '../ProfileProperty';
import { CustomFieldNumberModal } from './CustomFieldNumberModal';
import { CustomFieldPropertyProps } from './CustomFieldPropertyProps';

export const CustomFieldNumberProperty: FC<CustomFieldPropertyProps> = ({
  size = 'sm',
  color = 'gray',
  iconColor = 'light-gray',
  value,
  hideSuggestedChanges,
  onClick,
  onClose,
  ...field
}) => {
  const { hasEditingPermission } = useProfile();

  const handleClose = (fn: () => void) => {
    fn();
    onClose?.();
  };

  return (
    <ProfileProperty
      value={value?.value}
      canEdit={hasEditingPermission}
      params={{ size, iconColor, color }}
      renderLabel={() => <LongStringWithTooltip>{field.label}</LongStringWithTooltip>}
      valueText={field.label}
      editValueText={field.label}
      dataSet={SuggestedChangeDataSet.Telephones}
      hideSuggestedChanges={hideSuggestedChanges}
      modalController={({ isOpen, hide }) => (
        <CustomFieldNumberModal
          isOpen={isOpen}
          onClose={() => handleClose(hide)}
          field={field}
          value={value}
        />
      )}
      onClick={onClick}
    />
  );
};
